// src/components/Navbar.jsx
import { useState } from "react";

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(null); // 'services' or null

  const toggleMenu = () => setMenuOpen(!menuOpen);
  const toggleDropdown = (menu) =>
    setDropdownOpen(dropdownOpen === menu ? null : menu);

  return (
    <nav className="navbar" role="navigation" aria-label="Main Navigation">
      <a href="#home" className="logo">
        <img
          src="/logo.png"
          alt="KH Tiling and Painting"
          className="logo-img"
        />
        <span className="logo-text">KH Tiling and Painting</span>
      </a>

      <button
        className={`hamburger ${menuOpen ? "open" : ""}`}
        aria-label={menuOpen ? "Close menu" : "Open menu"}
        aria-expanded={menuOpen}
        aria-controls="main-menu"
        onClick={toggleMenu}
      >
        <span></span>
        <span></span>
        <span></span>
      </button>

      <ul className={`nav-menu ${menuOpen ? "open" : ""}`} id="main-menu">
        <li>
          <a href="#home">Home</a>
        </li>

        <li
          // className="dropdown"
          tabIndex={0}
          onClick={() => toggleDropdown("services")}
        >
          <a
            href="#services"
            aria-haspopup="true"
            aria-expanded={dropdownOpen === "services"}
          >
            Services
          </a>{" "}
        </li>

        <li>
          <a href="#gallery">Gallery</a>
        </li>
        <li>
          <a href="#about">About Us</a>
        </li>
        <li>
          <a href="#contact">Contact Us</a>
        </li>
      </ul>
    </nav>
  );
};

export default Navbar;
